import { useEffect } from 'react';
import { GqlProducts } from 'types/graphql';
import { tracker } from '..';

export const useViewedProductMonitor = (product?: GqlProducts): void => {
  useEffect(() => {
    if (product) {
      tracker.viewedProduct({ product });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product?.id /* only trigger when the product ID changes */]);
};
